import { render, staticRenderFns } from "./NetworkFormPage.vue?vue&type=template&id=1c36cd6f&scoped=true&"
import script from "./NetworkFormPage.vue?vue&type=script&lang=js&"
export * from "./NetworkFormPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c36cd6f",
  null
  
)

export default component.exports